/**
 * lazyloads carousel images
 * @module product-zoom
 */


 import $ from 'jquery';
 import registerJQueryPlugin from '../lib/register-jquery-plugin';
 import mergeOptions from '../lib/merge-options';
 import Cookies from 'js-cookie';
 export const PLUGIN_NAME = 'productZoom';
 //export const HOVER_EVENT = 'hover';
 export const DEFAULTS = {

 };

 const TAP_TO_ZOOM_BTN = '.product-zoom__btn';
 const ZOOM_CONTAINER = '.zoomContainer';
 const TAP_TO_ZOOM_BTN_ACTIVE = 'product-zoom__btn--active';
 const ZOOM_HIDE = 'js-plp-zoom--inactive';

 let intervalId;

 // Expose the function as a jQuery plugin for ease of use
 registerJQueryPlugin(PLUGIN_NAME, productZoom);

 /**
  * Initializes an toggleContent based on provided parameters.
  * @param {HTMLElement} el - An element containing the elements for the
  * toggleContent
  * @param {Object} options - Options used for wiring up the toggleContent
  * @see DEFAULTS
  */
 export default function productZoom(el, options = {}) {
   const $el = $(el);
   const opts = mergeOptions(DEFAULTS, options, $el);

   applyEventHandlers($el, opts);
 };


 /**
  * Applies any sort of event handlers for the toggleContent.
  * @param {jQuery} $el - Containing the elements for the toggleContent
  * @param {Object} options - Options used for wiring up the toggleContent
  * @see DEFAULTS
  */
  const applyEventHandlers = ($el, opts = {},) => {
      TOGGLE_BTN_ON_LOAD();
      CHECK_KEYBOARD();
      CHECK_FOR_ZOOM();
 }

// once zoom has initiated start delaying hover
 const CHECK_FOR_ZOOM = () => {
      intervalId = setInterval(function() {
          if ($(ZOOM_CONTAINER).length) {
              INITIALIZE_ZOOM();
          }
      }, 100);
 };

// remove active class to hide btn
 const HIDE_BTN = () => {
   $(TAP_TO_ZOOM_BTN).removeClass(TAP_TO_ZOOM_BTN_ACTIVE);
   $(TAP_TO_ZOOM_BTN).one('transitionend', function() {
     $(TAP_TO_ZOOM_BTN).hide();
   });
 }
 // add active class to show btn
 const SHOW_BTN = () => {
   $(TAP_TO_ZOOM_BTN).show().addClass(TAP_TO_ZOOM_BTN_ACTIVE);
 }
 // remove class hiding zoom
 const TRIGGER_ZOOM = () => {
   $(ZOOM_CONTAINER).removeClass(ZOOM_HIDE);
 }
 // add class hiding zoom
 const DELAY_ZOOM = () => {
   $(ZOOM_CONTAINER).addClass(ZOOM_HIDE);
 }
 // show and hide button on load
 const TOGGLE_BTN_ON_LOAD = () => {
   SHOW_BTN();
   setTimeout(function(){
     HIDE_BTN();
  }, 1000);
 }

 // start zoom event and clear interval
 const INITIALIZE_ZOOM = () => {
   clearInterval(intervalId);
   HOVER_HANDLER();
 }
// set cookie
 const SET_COOKIE = () => {
   Cookies.set('product-zoom-appeared', true, { expires: 7 });
 }
 // get cookie value
 const GET_COOKIE = () => {
   let cookieValue = Cookies.get('product-zoom-appeared');
   return cookieValue
 }
 // show button if cookie
 const CHECK_COOKIE = () => {
   if(!GET_COOKIE() === true) {
     SHOW_BTN();
   }
 }
 const CHECK_KEYBOARD = () => {
   $('.js-zoom-modal').on('click',function(e) {
     if($('.no-focus').length) {
       $(TAP_TO_ZOOM_BTN).hide();
     }
   });
   $('body').on('keydown', function(e) {
     var keyCode = e.keyCode || e.which;
     if(keyCode == 9) {
       $(TAP_TO_ZOOM_BTN).show();
     }
   });

 }

 const HOVER_HANDLER = () => {
   DELAY_ZOOM();
   $(ZOOM_CONTAINER).hover(function() {
     CHECK_COOKIE();
     setTimeout(function(){
       TRIGGER_ZOOM();
     }, 800);
   },
   function() {
     SET_COOKIE();
     HIDE_BTN();
     DELAY_ZOOM();
   });
 }



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/product-zoom.js